import { api } from "@/lib/api";

export interface AppleHealthSyncResult {
  success: boolean;
  syncedDays: number;
  error?: string;
  authFailed?: boolean;
}

export interface AppleHealthPermissionResult {
  granted: boolean;
  error?: string;
}

export async function getAppleHealthConnectionStatus(): Promise<{
  connected: boolean;
  lastSyncAt: string | null;
}> {
  type StatusResponse = { connected: boolean; lastSyncAt: string | null };
  const res = await api.get<StatusResponse>("/sync/apple-health/status");
  if (res.error) {
    return { connected: false, lastSyncAt: null };
  }
  return res.data as StatusResponse;
}

export async function disconnectAppleHealth(): Promise<{ success: boolean; error?: string }> {
  const res = await api.post("/sync/apple-health/disconnect");
  if (res.error) {
    return { success: false, error: res.error.message };
  }
  return { success: true };
}
